import { observable, action } from "mobx";
import SessaoStore from "../../../stores/SessaoStore";
import { Login } from "../../../services";
import { error } from "../../../utils/MensagemUtil";

class LoginStore {
  @observable
  login = "";

  @observable
  senha = "";

  @action.bound
  handleChange(event) {
    const { name, value } = event.target;

    this[name] = value;
  }

  @action.bound
  async logar(navigation) {
    const data = await Login.logar(this.login, this.senha);
    if (data.erro) {
      error(data.erro);
      return;
    }
    SessaoStore.setCurrent(data.access_token);
    navigation.push("/dashboard");
  }
}

export default new LoginStore();



// WEBPACK FOOTER //
// ./src/views/autenticacao/stores/LoginStore.js